import styled from "styled-components";

export const Container = styled.div`
    display: flex;

    background-color: ${(props) => props.theme.colors.white};
    box-shadow: 0px 1px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;

    padding: 5px 10px;  
`;

export const Button = styled.button<{isActive: boolean}>`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 125px;
    
    background-color: transparent;
    color: ${(props) => props.isActive ? props.theme.colors.error : props.theme.colors.gray.gray_800};
    padding: 5px 10px;
    
    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
    
    @media (max-width: 900px) {
        width: 100%;
        justify-content: center;
    }
`;

export const Title = styled.p`
    @media (max-width: 900px) {
        display: none;
    }
`;